(() => {
  if(customElements.get('hx-nad-gallery-curve'))return;
  customElements.define('hx-nad-gallery-curve',class extends HTMLElement{
    connectedCallback(){
      if(this.controller)return;this.controller=new AbortController();const options={signal:this.controller.signal};
      this.points=JSON.parse(this.querySelector('[data-nr-points]').textContent);
      this.labels=JSON.parse(this.querySelector('[data-nr-labels]').textContent);
      this.range=this.querySelector('[data-nr-range]');this.index=14;this.motion=matchMedia('(prefers-reduced-motion:reduce)');
      this.range.addEventListener('input',()=>this.select(Number(this.range.value)),options);
      this.querySelectorAll('[data-nr-stage]').forEach(button=>button.addEventListener('click',()=>this.select(Number(button.dataset.nrStage)),options));
      this.select(14);
      this.mediaColumn=this.closest('.hx-product-media-column');
      if(this.mediaColumn){
        this.updateSticky=()=>{
          cancelAnimationFrame(this.stickyFrame);
          this.stickyFrame=requestAnimationFrame(()=>{
            this.mediaColumn.style.setProperty('--hx-media-height',Math.ceil(this.mediaColumn.getBoundingClientRect().height)+'px');
          });
        };
        this.resizeObserver=new ResizeObserver(this.updateSticky);
        this.resizeObserver.observe(this.mediaColumn);
        window.addEventListener('resize',this.updateSticky,options);
        this.updateSticky();
      }
      this.observer=new IntersectionObserver(entries=>{
        if(!entries[0].isIntersecting)return;this.observer.disconnect();
        if(!this.motion.matches)this.querySelector('.hx-nr-line').animate([{strokeDasharray:'1000',strokeDashoffset:1000},{strokeDasharray:'1000',strokeDashoffset:0}],{duration:1100,easing:'cubic-bezier(.2,.7,.2,1)'});
      },{threshold:.25});this.observer.observe(this);
    }
    select(day){
      day=Math.max(0,Math.min(56,Math.round(day)));
      const measured=this.points.find(point=>point.day===day);
      const point=measured || this.curvePoint(day);
      const label=this.labels.days.replace('[day]',String(day));
      const summary=measured?measured.summary:label+'. '+this.labels.unmeasured;
      const dot=this.querySelector('[data-nr-dot]');const old={x:Number(dot.getAttribute('cx')),y:Number(dot.getAttribute('cy'))};this.index=day;this.range.value=String(day);this.range.setAttribute('aria-valuetext',summary);
      this.querySelector('[data-nr-increase]').firstChild.textContent=measured?(point.increase>0?'+':'')+point.increase:'—';
      this.querySelector('[data-nr-increase] span').hidden=!measured;
      this.querySelector('[data-nr-index]').textContent=measured?point.index:'—';this.querySelector('[data-nr-measure-label]').textContent=label;
      this.querySelector('[data-nr-status]').textContent=summary;
      this.querySelectorAll('[data-nr-stage]').forEach(button=>button.setAttribute('aria-pressed',String(Number(button.dataset.nrStage)===day)));
      cancelAnimationFrame(this.frame);let start;const duration=this.motion.matches?0:340;
      const tick=time=>{if(start===undefined)start=time;const p=duration===0?1:Math.min((time-start)/duration,1),ease=1-(1-p)**3,x=old.x+(point.x-old.x)*ease,y=old.y+(point.y-old.y)*ease;
        this.querySelectorAll('[data-nr-ring],[data-nr-dot]').forEach(dot=>{dot.setAttribute('cx',String(x));dot.setAttribute('cy',String(y));});
        const guide=this.querySelector('[data-nr-guide]');guide.setAttribute('x1',String(x));guide.setAttribute('x2',String(x));
        if(p<1)this.frame=requestAnimationFrame(tick);
      };this.frame=requestAnimationFrame(tick);
    }
    curvePoint(day){
      const x=45+(530-45)*day/56,path=this.querySelector('.hx-nr-trace');
      let lo=0,hi=path.getTotalLength();
      for(let i=0;i<16;i++){const mid=(lo+hi)/2;if(path.getPointAtLength(mid).x<x)lo=mid;else hi=mid;}
      return path.getPointAtLength((lo+hi)/2);
    }
    disconnectedCallback(){this.controller?.abort();this.controller=null;this.observer?.disconnect();this.resizeObserver?.disconnect();cancelAnimationFrame(this.frame);cancelAnimationFrame(this.stickyFrame);}
  });
})();
